import { mainSiteUrl } from '@/mocks/categories';

const steps = [
  {
    number: '01',
    icon: 'ri-search-line',
    title: 'Find Products',
    desc: 'Browse the organized Vigorbuy Spreadsheet with thousands of verified product links across categories.',
  },
  {
    number: '02',
    icon: 'ri-scales-3-line',
    title: 'Compare Options',
    desc: 'Review quality details, compare prices, and check product information before making decisions.',
  },
  {
    number: '03',
    icon: 'ri-book-open-line',
    title: 'Learn & Verify',
    desc: 'Use our QC guides and safety tips to ensure you are making informed shopping choices.',
  },
  {
    number: '04',
    icon: 'ri-external-link-line',
    title: 'Visit & Shop',
    desc: 'Head to Kaspreadsheet with confidence, armed with the best vigorbuy spreadsheet knowledge.',
  },
];

export default function HowItWorks() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-4">
            How It Works
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Shop Smarter in <span className="italic">Four Steps</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {steps.map((step, i) => (
            <div key={step.number} className="relative flex flex-col items-center text-center group">
              {/* Step Number */}
              <span className="text-7xl md:text-8xl font-bold font-heading text-background-200 group-hover:text-primary-200 transition-colors duration-300">
                {step.number}
              </span>

              {/* Icon Circle */}
              <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 -mt-8 mb-4 relative z-10 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${step.icon} text-xl`}></i>
              </span>

              {/* Title & Desc */}
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {step.desc}
              </p>

              {/* Connector Arrow */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-5 top-12 text-foreground-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Start Exploring
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}